async function setupSW() {
    if (!('serviceWorker' in navigator)) return;
    try {
        const res = await fetch('/meta.json?cb=' + Date.now(), { cache: 'no-store' });
        const meta = await res.json();
        const version = meta && meta.version ? String(meta.version) : '';
        const hadController = !!navigator.serviceWorker.controller;
        const reg = await navigator.serviceWorker.register('/sw.js?v=' + encodeURIComponent(version), { updateViaCache: 'none' });

        const handleInstalling = (sw) => {
            if (!sw) return;
            sw.addEventListener('statechange', () => {
                if (sw.state === 'installed' && hadController) {
                    window.location.reload();
                }
            });
        };

        handleInstalling(reg.installing);

        reg.addEventListener('updatefound', () => {
            handleInstalling(reg.installing);
        });

        navigator.serviceWorker.addEventListener('controllerchange', () => {
            if (hadController) {
                window.location.reload();
            }
        });

        const updateOnAttention = () => {
            if (document.visibilityState === 'visible') {
                reg.update();
            }
        };
        window.addEventListener('visibilitychange', updateOnAttention);
        window.addEventListener('online', () => reg.update());
    } catch (e) {
        // ignore registration errors
    }
}

export default setupSW;